import script from "./navAiToolMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./navAiToolMenu.vue?vue&type=script&setup=true&lang=js"

import "./navAiToolMenu.vue?vue&type=style&index=0&id=52be42a6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-52be42a6"]])

export default __exports__